import axios from "axios";
import { API_SUSCRIPCION_PLACA, HEADERS, ID_CUENTA } from "config/general/Configuracion";

class ApiClient {
  constructor() {
    this.url = API_SUSCRIPCION_PLACA;
  }

  listarSuscripcionPlaca = (paginacion) => {
    var query = "limite=" + encodeURIComponent(paginacion.limite);
    query += "&actual=" + encodeURIComponent(paginacion.actual);
    if (paginacion.filtro) {
      query += "&filtro=" + encodeURIComponent(paginacion.filtro);
    }
    if (paginacion.orden) {
      query += "&orden=" + encodeURIComponent(paginacion.orden);
    }
    if (paginacion.sentido) {
      query += "&sentido=" + encodeURIComponent(paginacion.sentido);
    }
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/suscripcionPlaca/listado/${encodeURIComponent(
        localStorage[ID_CUENTA]
      )}?${query}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarPlacasActivas = () => {
    return axios.get(
      `${this.url}/v1/suscripcionPlaca/listadoPlacas/${localStorage[ID_CUENTA]}`,
      {
        headers: HEADERS(),
      }
    );
  };

  listarPlanesActivos = () => {
    return axios.get(
      `${this.url}/v1/suscripcionPlaca/listadoPlanes/${localStorage[ID_CUENTA]}`,
      {
        headers: HEADERS(),
      }
    );
  };


  guardarSuscripcionPlaca = (suscripcionPlaca) => {
    let respuesta = {
      method: "post",
      url: `${this.url}/v1/suscripcionPlaca/guardar/${encodeURIComponent(
        localStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
      data: suscripcionPlaca,
    };
    return respuesta;
  };

  
}
const SuscripcionPlacaApi = new ApiClient();
export default SuscripcionPlacaApi;
